import * as React from 'react';
import px from 'prop-types';
import { useSelector } from 'react-redux';
import { order, product } from '~features';
import { LinkItem } from 'Common/types';
import { ProductView as Product } from 'Common/components/product';
import { ProductDetails, ProductGallery, RelatedProducts } from '~components/product';
import * as GTM from 'Common/constants/gtm';


export default function ProductView({
    allowDisplayOnlyVariants = false,
    attributesToDisplay = [{}],
    checkoutPageLink,
    detailsProps,
    includeDescription = false,
    isUserAuthenticated,
    pageId,
    ProductDetailsComponent = ProductDetails,
    ProductGalleryComponent = ProductGallery,
    RelatedProductsComponent = RelatedProducts,
    reviewProviderEntityId,
    showRelatedEntries = 'None',
    siteId,
    storeLocatorLink,
    useChildTable,
    useCompare = false,
    useSocialShare = false,
    writeReviewAnchor,
    ...props
}) {
    const totalQty = useSelector(order.selectors.getTotalQuantity);
    const productTitle = useSelector(product.selectors.getChildTitle);
    const currentMarketingBadges = useSelector(product.selectors.getCurrentMarketingBadges);

    return (
        <Product
            {...props}
            detailsProps={{
                allowDisplayOnlyVariants,
                checkoutPageLink,
                gtmListValue: GTM.TAGS.PDP,
                includeDescription,
                pageId,
                reviewProviderEntityId,
                siteId,
                storeLocatorLink,
                totalQty,
                useCompare,
                useSocialShare,
                writeReviewAnchor,
                ...detailsProps,
            }}
            attributesToDisplay={attributesToDisplay}
            currentMarketingBadges={currentMarketingBadges}
            Details={ProductDetailsComponent}
            Gallery={ProductGalleryComponent}
            isUserAuthenticated={isUserAuthenticated}
            prodcutId={reviewProviderEntityId}
            productTitle={productTitle}
            Related={RelatedProductsComponent}
            showRelatedEntries={showRelatedEntries === 'Sidebar'}
            useChildTable={useChildTable}
        />
    );
}

ProductView.propTypes = {
    allowDisplayOnlyVariants: px.bool,
    attributesToDisplay: px.arrayOf(px.object),
    checkoutPageLink: px.string,
    detailsProps: px.objectOf(px.any),
    gtmListValue: px.string,
    hideRelatedProducts: px.bool,
    includeDescription: px.bool,
    isUserAuthenticated: px.bool,
    pageId: px.oneOfType([px.string, px.number]),
    ProductDetailsComponent: px.elementType,
    ProductGalleryComponent: px.elementType,
    RelatedProductsComponent: px.elementType,
    reviewProviderEntityId: px.string,
    showRelatedEntries: px.oneOf(['Sidebar', 'Carousel', 'None', '']),
    siteId: px.string,
    storeLocatorLink: LinkItem,
    useChildTable: px.bool,
    useCompare: px.bool,
    useSocialShare: px.bool,
    writeReviewAnchor: px.string,
};
